import { render, staticRenderFns } from "./MyBut.vue?vue&type=template&id=5d9e36cd&scoped=true&"
import script from "./MyBut.vue?vue&type=script&lang=js&"
export * from "./MyBut.vue?vue&type=script&lang=js&"
import style0 from "./MyBut.vue?vue&type=style&index=0&id=5d9e36cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e36cd",
  null
  
)

export default component.exports